import { NgModule } from '@angular/core';

import { LzLogDirective } from './directives/lz-log.directive';

import { LzLogService } from "./services/lz-log.service";

@NgModule({
  imports: [ ],
  providers: [
    LzLogService
  ],
  declarations: [
    LzLogDirective
  ],
  exports: [
    LzLogDirective
  ]
})

export class LzLogModule { }
